import { SelectCasesType } from '@lp/features/MultiSuggest/types';
import { Button } from '@ds';

type ActionButtonsProps = {
  type: SelectCasesType;
  isNextDisabled: boolean;
  isProceedLoading: boolean;
  onNextPage: () => Promise<void>;
  onPrevPage: () => Promise<void>;
  onProceed: () => Promise<void>;
  onClose: () => void;
};

export const ActionButtons = ({
  type,
  isNextDisabled,
  isProceedLoading,
  onNextPage,
  onPrevPage,
  onProceed,
  onClose,
}: ActionButtonsProps) => {
  return (
    <div className="flex justify-end gap-2">
      <Button size="md" variant="light" onPress={onClose}>
        Cancel
      </Button>
      {type === SelectCasesType.Initial ? (
        <Button size="md" variant="solid" onPress={onNextPage} isDisabled={isNextDisabled}>
          Next
        </Button>
      ) : (
        <>
          <Button size="md" variant="outline" onPress={onPrevPage}>
            Back
          </Button>
          <Button size="md" onPress={onProceed} isDisabled={isNextDisabled} isLoading={isProceedLoading}>
            Proceed
          </Button>
        </>
      )}
    </div>
  );
};
